import React, { useState, useEffect, useCallback } from 'react';
import { RefreshCw, CheckCircle, AlertTriangle } from 'lucide-react';
import apiService from '../../../apiService';
import { fmtMoney, fmtInt, fmtDate, Card, Spinner, SEVERITY_META } from '../financeShared';

export default function ReconciliationTab({ currency, rate }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState({});
  const fmt = (n) => fmtMoney(n, currency, rate);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiService.get('/admin/finance/reconciliation', { userType: 'admin' });
      if (res?.success) setData(res);
    } catch (e) { console.error('reconciliation:', e); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const checks = data?.checks || [];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <div>
          {data && (data.issues > 0
            ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#FF9B00', fontWeight: 700 }}><AlertTriangle size={18} /> {data.issues} anomalie(s) à traiter</span>
            : <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#10B981', fontWeight: 700 }}><CheckCircle size={18} /> Aucune anomalie détectée</span>)}
        </div>
        <button className="btn-secondary" onClick={load} style={{ padding: '0.4rem 1rem', display: 'flex', alignItems: 'center', gap: 6 }}><RefreshCw size={15} /> Actualiser</button>
      </div>

      {loading ? <Spinner /> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.9rem' }}>
          {checks.map(c => {
            const sev = SEVERITY_META[c.count > 0 ? c.severity : 'ok'];
            const isOpen = open[c.key];
            return (
              <Card key={c.key} style={{ padding: '1rem 1.25rem', borderLeft: `4px solid ${sev.color}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: c.count > 0 ? 'pointer' : 'default' }}
                  onClick={() => c.count > 0 && setOpen(o => ({ ...o, [c.key]: !o[c.key] }))}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: '0.7rem', padding: '0.2rem 0.55rem', borderRadius: '10px', background: sev.bg, color: sev.color, fontWeight: 700 }}>{sev.label}</span>
                    <span style={{ fontWeight: 600, color: '#1E2229' }}>{c.label}</span>
                  </div>
                  <span style={{ fontWeight: 700, color: c.count > 0 ? sev.color : '#10B981', fontSize: '1.1rem' }}>{fmtInt(c.count)}</span>
                </div>
                {isOpen && c.sample?.length > 0 && (
                  <div style={{ marginTop: '0.9rem', overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                      <thead><tr style={{ borderBottom: '1px solid #E9EBEF', color: '#9AA0A8' }}>
                        <th style={{ textAlign: 'left', padding: '0.4rem' }}>Référence</th>
                        <th style={{ textAlign: 'left', padding: '0.4rem' }}>Détail</th>
                        <th style={{ textAlign: 'right', padding: '0.4rem' }}>Montant</th>
                        <th style={{ textAlign: 'right', padding: '0.4rem' }}>Date</th>
                      </tr></thead>
                      <tbody>
                        {c.sample.map((s, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #F4F5F7' }}>
                            <td style={{ padding: '0.4rem', fontFamily: 'monospace', color: '#414852' }}>{s.id}</td>
                            <td style={{ padding: '0.4rem', color: '#5C636E' }}>{s.type || s.category || (s.count != null ? `${s.count}×` : '—')}</td>
                            <td style={{ padding: '0.4rem', textAlign: 'right', fontWeight: 600, color: '#1E2229' }}>{s.amount != null ? fmt(s.amount) : '—'}</td>
                            <td style={{ padding: '0.4rem', textAlign: 'right', color: '#9AA0A8' }}>{s.date ? fmtDate(s.date) : '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      )}
    </>
  );
}
